<script setup lang="ts">
/**
 * TODO
 * - [ ] scroll triggers per column
 * - [ ] drag and drop per column
 */
const { state: viewModeState, defaultColumnModeWidth } = useViewMode()
const { onColumnViewMounted, onColumnViewUnmounted, onUpdatedViewModeSettings, contentsByColumn } = useColumnView()
// We don't have a scroll container here so we just place this on the global object
const { collectionScrollContainerId } = useGlobals()

onMounted(() => onColumnViewMounted())
onUnmounted(() => onColumnViewUnmounted())
watch(() => viewModeState.value.current, onUpdatedViewModeSettings)
</script>

<template>
  <interface-scrollbar horizontal>
    <div :id="collectionScrollContainerId" class="column-view">
      <collection-column-single
        v-for="{ files, folder }, index in contentsByColumn"
        :key="index"
        :column-width="viewModeState.current.columnView?.columns[index] || defaultColumnModeWidth"
        :index
        :files
        :folder
      />
    </div>
  </interface-scrollbar>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
.column-view
  @apply h-full flex
</style>
